import { TipDetail, WorkDay } from '@core/models';
import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { TipCalculationStrategy } from '../interfaces/tip-calculation-strategy.interface';

export class FixedTipStrategy implements TipCalculationStrategy {
	calculateAmount(
		tip: TipDetail,
		_subtotal: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): bigint {
		const rawAmount = tip.value ?? tip.valor;
		return precisionService.toInternalFromDecimal(rawAmount, workDay);
	}

	calculateOption(
		tip: TipDetail,
		_subtotal: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): TipDetail {
		return {
			...tip,
			percent: 0,
			value: precisionService.toDecimalNumberFromInternal(tip.valor, workDay),
		};
	}
}
